import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import AssessmentIcon from '@mui/icons-material/Assessment';
import { Box } from '@mui/material';

import { SCUILoadingLinear } from '../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { SCUIContent } from '../../../atomic/organisms';
import SummaryAggregationQuery from '../../../services/query/summaryAggregation/SummaryAggregationQuery.services';
import { PageUrl } from '../../../types/enums/pageUrl-enums';

import { NetSalesList } from './components';
import { NS } from './netSales.classes';

const formatParamDate = (date: string | Date): string => {
    if (!date) return '';
    if (typeof date === 'string') {
        return date.includes('T') ? date.split('T')[0] : date;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const NetSales = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [netSalesList, setNetSalesList] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string | Date>('');
    const [endDate, setEndDate] = useState<string | Date>('');
    const [isSearched, setIsSearched] = useState<boolean>(false);

    const { t } = useTranslation();

    const handleSearch = () => {
        setIsLoading(true);
        setIsSearched(true);
        SummaryAggregationQuery.GetConsolidationList({
            StartDate: formatParamDate(startDate),
            EndDate: formatParamDate(endDate),
        })
            .then((res: any) => {
                const items = (res?.items || []).map((item: any, index: number) => ({
                    ...item,
                    id: item?.consolidationDate ? `${item.consolidationDate}-${index}` : index,
                }));
                setNetSalesList(items);
                setIsLoading(false);
            })
            .catch(() => {
                Swal.fire(t('general.anErrorOccured'), '', 'error');
                setIsLoading(false);
            });
    };

    return (
        <SCUIContent className={NS.page}>
            <Box className={NS.root}>
                <Box
                    className={NS.breadcrumb}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <AssessmentIcon className={NS.titleIcon} color="primary" fontSize="large" />
                    <SCUIBreadCrumb
                        onlyTitle={t('summaryAggregation.netSales.title')}
                        components={[
                            {
                                title: t('summaryAggregation.netSales.title'),
                                link: PageUrl.summaryAggregation.netSales.url,
                            },
                        ]}
                    />
                </Box>
                {isLoading && (
                    <Box sx={{ margin: '24px 0' }} className={NS.loading}>
                        <SCUILoadingLinear display={isLoading} />
                    </Box>
                )}
                <NetSalesList
                    netSalesList={netSalesList}
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    handleSearch={handleSearch}
                    isSearched={isSearched}
                />
            </Box>
        </SCUIContent>
    );
};
